module.exports = __webpack_public_path__ + "static/media/miracleQuestion.4ce32b52.png";